import React from 'react'
import IMG7 from "../Images/react.jpg"
function ReactLogo() {
  return (
    <>
<img src={IMG7} style={{width:"200px",height:"150px"}} alt='reactjs' />
    </>
  )
}

export default ReactLogo